import { motion, useReducedMotion } from 'framer-motion';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

export function PageTransition({ children }: { children: React.ReactNode }): React.JSX.Element {
  const location = useLocation();
  const shouldReduce = useReducedMotion();

  return (
    <motion.div
      key={location.pathname}
      initial={shouldReduce ? false : { opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }}
      style={{ minHeight: '100%' }}
    >
      {children}
    </motion.div>
  );
}
